// Auto-stamped on every Phase ship. Bump this string when you want
// /api/build, the <meta name="x-app-build"> tag, and the Superadmin
// Overview tab to show a new build value. End-users no longer see this
// string on /, /login, /signup, /legal/*.
export const BUILD_STAMP =
  "20260619-chat-sort-flip";
export const BUILD_NOTE =
  "Chat list newest-at-bottom: server returns oldest→newest, sidebar auto-scrolls to bottom (sticky if near-bottom)";
